import React, { useState } from "react";
import './ReleasePet.css';

const Services = () => {
  const poster = require('../assets/poster.jpg')
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [animal, setAnimal] = useState('');
  const [petname, setPetname] = useState('');
  const [petbreed, setPetbreed] = useState('');
  const [petgender, setPetgender] = useState('');
  const [contact, setContact] = useState('');
  const [fileName, setFileName] = useState('');

  const [releasePet, setReleasepet] = useState([]);
  const record = JSON.parse(localStorage.getItem('releasePet')) || [];

  const checkNumerical = (event) => {
    const inputValue = event.target.value;
    if (!isNaN(inputValue)) {
      setContact(inputValue);
      event.target.setCustomValidity('');
    } else {
      event.target.setCustomValidity('Please enter a valid number');
    }
  };

  const handleFileUpload = (event) => {
    if (event.target.files.length > 0) {
      setFileName(event.target.files[0].name);
      // alert('File uploaded successfully!');
    }
  };

  const submit = (event) => {
    event.preventDefault();
    alert("Form submitted successfully.\nOur team will contact you with more details within 1-3 working days.");
    const newEntry = { name, contact, email, animal, petname, petbreed, petgender, fileName }
    record.push(newEntry);
    localStorage.setItem('releasePet', JSON.stringify(record));

    setName('');
    setContact('');
    setEmail('');
    setAnimal('');
    setPetname('');
    setPetbreed('');
    setPetgender('');
    setFileName('');
  };

  return (
    <div className="releasePage">
      <img className="poster" src={poster}></img>
      <div className='releaseDiv'>
        <br />
        <div className="descriptionDiv">
          <h1>Release Pet</h1>
          <br />
          <p>Releasing a pet to the shelter is a significant decision and should be made with careful consideration. This form helps gather necessary information about the owner and the pet to ensure a smooth transition. Please fill out all the required fields accurately.</p>
        </div>
        <form className="releaseForm" onSubmit={submit}>
          <label>Your Details</label>

          <input type='text'
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)} />

          <input
            placeholder="Phone Number"
            type='tel'
            maxLength="8"
            pattern="[0-9]{8}"
            value={contact}
            onChange={checkNumerical}
            required />

          <input
            type='email'
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)} />

          <br />

          <label>Your Pet's Details</label>
          <select onChange={(e) => setAnimal(e.target.value)}>
            <option hidden>Choose an animal</option>
            <option>Dog</option>
            <option>Cat</option>
            <option>Rabbit</option>
            <option>Others</option>
          </select>
          <input type='text' placeholder="Pet's Name" value={petname} onChange={(e) => setPetname(e.target.value)}></input>
          <input type='text' placeholder="Breed" value={petbreed} onChange={(e) => setPetbreed(e.target.value)}></input>
          
          <select value={petgender} onChange={(e) => setPetgender(e.target.value)}>
            <option hidden>Animal Gender</option>
            <option>Male</option>
            <option>Female</option>
          </select>
          <div className="upload">
            <label htmlFor="file-upload" className="custom-file-upload">
              Upload Image
            </label>
            {fileName && <p className="file-name">{fileName}</p>}
          </div>
          <input id="file-upload" type="file" onChange={handleFileUpload} />
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default Services;